import EntityPrintoutQuery from "@/server/com/silkplm/engine/model/EntityPrintoutQuery";
import Rpc from "@/Rpc";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import DialogManager from "@/utils/DialogManager";
import PPSamplesProduct from "@/server/com/silkplm/model/plm/PPSamplesProduct";
import FormViewConfig from "@/server/com/silkplm/engine/forms/views/FormViewConfig";

class _PrintoutManager {
    constructor() {
    }

    async formPrintout(formConfig, printoutClazz, entityInstance) {
        let language = localStorage.getItem("printout.language") || SessionManager.defaultInterfaceLanguageCode || "en";

        //TODO Wyjasnic
        let shouldRemember = true;

        if (!SessionManager.hasFlag(FeatureFlag.ASK_FOR_LANGUAGE_FOR_INQUIRY_DIALOG)) {
            let anotherTemplate = await DialogManager.checkBox(
                $tr("printout.dialog.another.template", "Would you like to choose another template?"),
                $tr("printout.dialog.horizontal.template", "Horizontal template"))

            if (anotherTemplate === null || anotherTemplate === false) {
                return await this._executePrintout(formConfig, printoutClazz, entityInstance, language);
            } else {
                printoutClazz = await Rpc.plm.services.OrderService.checkIfHorizontalTemplateForPrintout(printoutClazz)
                return await this._executePrintout(formConfig, printoutClazz, entityInstance, language);
            }

        } else {
            let horizontalTemplate = await Rpc.plm.services.OrderService.checkIfHorizontalTemplateForPrintout(printoutClazz);
            this.result = await DialogManager.printoutLanguageDialog(shouldRemember, language, formConfig, printoutClazz, entityInstance, false, horizontalTemplate);
        }

    }

    // async formPrintoutForSuppliers(formConfig,printoutClazz, entityInstance){
    //     let language =
    // }

    async _executePrintout(formConfig, printoutClazz, entityInstance, language) {
        if (!formConfig) {
            return;
        }
        let clazz = formConfig.formClassLong;
        if (formConfig instanceof FormViewConfig) {
            clazz = formConfig.masterClass;
        }
        formConfig.languageForPrintOut = language;
        let task = await Rpc.Printouts.schedulePrintoutJob(printoutClazz,
            new EntityPrintoutQuery().withClazz(clazz).withId(entityInstance.id).withLanguage(language)
        );
        return task;
    }

}

const PrintoutManager = new _PrintoutManager();
window['PrintoutManager'] = PrintoutManager;

export default PrintoutManager;
